import Api from './Api';
import moment from 'moment';
import {store} from '../store/index';

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId'];
}

export default {
  async getEntitlementMetadata (id) {
    return new Api().get(`dashboard/api/v1/orgs/${getOrgId()}/filters/EntitlementXml`);
  },
  async getEntitlementUsage (id) {
    let today = moment().format('YYYY-MM-DD');
    let queryData = {
      endpointCountRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.endpointcount)"},
      endpointLimitRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.endpointlimit)"},

      meetingUserCountRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.meetingusercount)"},
      meetingUserLimitRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.meetinguserlimit)"},

      audioUserCountRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.audiousercount)"},
      audioUserLimitRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.audiouserlimit)"},

      roomCountRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.roomcount)"},
      roomLimitRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.roomlimit)"},

      nonTechRoomCountRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.nontechroomcount)"},
      nonTechRoomLimitRequest: {"start": today,"end": today,"aggregateFact":"max(fctorgentitlement.nontechroomlimit)"},

      orgDataRequest: {
        dataset: "orgxml"
      }
    };
    return new Api().post(`dashboard/api/v1/orgs/${getOrgId()}/data`, queryData);
  },
};
